export const SAVE_SESSION_STARTED = "SAVE_SESSION_STARTED";
export const SAVE_SESSION_COMPLETED = "SAVE_SESSION_COMPLETED";
export const SAVE_SESSION_FAILED = "SAVE_SESSION_FAILED";
export const GET_SESSION_STARTED = "GET_SESSION_STARTED";
export const GET_SESSION_COMPLETED = "GET_SESSION_COMPLETED";
export const GET_SESSION_FAILED = "SAVE_SESSION_FAILED";

export interface ISession {
  status: {
    statusCode: number;
    statusDisplay: string;
    statusValue: boolean;
  };
  items: Array<any>;
  loginInput: {
    userId: string;
    password: string;
    securityQuestion: string;
    answer: string;
    roleFkId: {
      roleId: number;
      roleName: string;
      description: string;
      status: number;
      createdAt: Date;
      createdBy: string;
      updatedAt: Date;
      updatedBy: string;
    };
    status: number;
    createdAt: Date;
    createdBy: string;
    updatedAt: Date;
    updatedBy: string;
  };
  loginID: number;
  isLoading: boolean;
  error: string;
}

export const saveSession = (sessionInput: any) => {
 
  return {
    type: SAVE_SESSION_STARTED,
    payload: "status",
    input: sessionInput
  };
};

export const getSession = (sessionInput: any) => {
 
    return {
      type: GET_SESSION_STARTED,
      payload: "status",
      input: sessionInput
    };
  };